<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        text
        small
        class="language-selector"
        :aria-label="$t('Language')"
        v-bind="attrs"
        v-on="on"
      >
        <img
          :src="$i18n.locale === 'es-ES' ? flags.es : flags.en"
          class="language-flag"
          alt=""
          aria-hidden="true"
        >
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item
        :disabled="saving"
        @click="choose('en')"
      >
        <v-list-item-icon class="language-option-icon">
          <img :src="flags.en" class="language-flag" alt="" aria-hidden="true">
        </v-list-item-icon>
        <v-list-item-title lang="en">
          English
        </v-list-item-title>
      </v-list-item>
      <v-list-item
        :disabled="saving"
        @click="choose('es-ES')"
      >
        <v-list-item-icon class="language-option-icon">
          <img :src="flags.es" class="language-flag" alt="" aria-hidden="true">
        </v-list-item-icon>
        <v-list-item-title lang="es">
          Español
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
import { setLocale } from '@/i18n'
import englishFlag from '@/assets/images/flags/us.svg'
import spanishFlag from '@/assets/images/flags/es.svg'

export default {
  data: () => ({ saving: false, flags: { en: englishFlag, es: spanishFlag } }),
  methods: { async choose(locale) { this.saving = true; try { await setLocale(locale) } finally { this.saving = false } } },
}
</script>
<style scoped>
.language-selector { min-width: 40px !important; padding: 0 6px !important; letter-spacing: .04em; }
.language-flag { display: block; width: 24px; height: 16px; object-fit: cover; border-radius: 2px; box-shadow: 0 0 0 1px rgba(0, 0, 0, .12); }
.language-option-icon { min-width: 24px; margin-right: 12px !important; align-self: center; }
</style>
